"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AnimatedSprite = void 0;

var PIXI = _interopRequireWildcard(require("pixi.js"));

var _Sprite = require("./Sprite");

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};

  if (obj != null) {
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

        if (desc && (desc.get || desc.set)) {
          Object.defineProperty(newObj, key, desc);
        } else {
          newObj[key] = obj[key];
        }
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

var AnimatedSprite = (0, _Sprite.createSprite)('AnimatedSprite', function (_ref) {
  var textures = _ref.textures,
      autoUpdate = _ref.autoUpdate;
  return new PIXI.AnimatedSprite(textures, autoUpdate);
}, function (sprite, _ref2) {
  var textures = _ref2.textures,
      _ref2$playing = _ref2.playing,
      playing = _ref2$playing === void 0 ? true : _ref2$playing,
      _ref2$loop = _ref2.loop,
      loop = _ref2$loop === void 0 ? true : _ref2$loop,
      _ref2$animationSpeed = _ref2.animationSpeed,
      animationSpeed = _ref2$animationSpeed === void 0 ? 1 : _ref2$animationSpeed;
  if (textures !== sprite.textures) sprite.textures = textures;
  if (playing !== sprite.playing) playing ? sprite.play() : sprite.stop();
  if (loop !== sprite.loop) sprite.loop = loop;
  if (animationSpeed !== sprite.animationSpeed) sprite.animationSpeed = animationSpeed;
});
exports.AnimatedSprite = AnimatedSprite;